export const toneChip: Record<string, string> = {
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  primary: "bg-primary-100 text-primary-900 border-primary-200",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  foreground: "bg-background-200 text-foreground-800 border-background-300",
};

export const toneDot: Record<string, string> = {
  accent: "bg-accent-500",
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
  foreground: "bg-foreground-700",
};

export const toneSoft: Record<string, string> = {
  accent: "bg-accent-50",
  primary: "bg-primary-50",
  secondary: "bg-secondary-50",
  foreground: "bg-background-100",
};

export const toneIcon: Record<string, string> = {
  accent: "bg-accent-100 text-accent-700",
  primary: "bg-primary-100 text-primary-700",
  secondary: "bg-secondary-100 text-secondary-700",
  foreground: "bg-background-200 text-foreground-700",
};

export const toneBar: Record<string, string> = {
  accent: "bg-accent-500",
  primary: "bg-primary-500",
  secondary: "bg-secondary-500",
  foreground: "bg-foreground-600",
};